import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { NodeItem } from '../models/node.model';

@Component({
    selector: 'file-list',
    templateUrl: './file-list.component.html',
    standalone: false
})
export class FileListComponent implements OnInit {
  @Input() public node: NodeItem;
  @Input() public updateSubject: Subject<any>;
  public selectable: Boolean = true;

  @Output() public toggleOpenNode: EventEmitter<any> = new EventEmitter();
  @Output() public toggleSelectNode: EventEmitter<any> = new EventEmitter();

  @Output() public toggleGotoNodeParent: EventEmitter<any> = new EventEmitter();
  @Output() public toggleHandleInputChange: EventEmitter<any> = new EventEmitter();

  public selection: any = {};
  errorMessage: string;
  orderByFieldName = 'name';
  direction = 'asc';
  @Input() query = '';
  public loading: Boolean = true;
  // temporary
  public allItems: any = [];

  constructor() {}

  ngOnInit(): void {
    this.initData();
    if (this.updateSubject) {
      this.updateSubject.subscribe((data) => this.initData());
    }
  }

  initData() {}

  public selectNode(e: any, node: NodeItem) {
    e.stopPropagation();
    this.toggleSelectNode.emit(node);
  }

  public openNode(node: NodeItem) {
    this.toggleOpenNode.emit(node);
  }

  public gotoNodeParent(node: NodeItem) {
    this.toggleGotoNodeParent.emit(node);
  }

  public handleInputChange(e: any) {
    this.toggleHandleInputChange.emit(e);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }
}
